import { useCallback, useState } from "react";
import VacancyForm from "../Vacancies/Form";
import VacancyEditMode from "./VacancyEditMode";
import VacancyViewMode from "./VacancyViewMode";
import { router } from "@inertiajs/react";
import { vacancies, matches } from "@/api";
import WeightSettings from "./WeightSettings";
import { DEFAULT_SCORE_WEIGHTS } from "@/utils/weights";

export default function New({ vacancy, vacancy_file }) {
  const [edit, setEdit] = useState(false);
  const [weights, setWeights] = useState(DEFAULT_SCORE_WEIGHTS);

  const updateVacancy = useCallback((data) => {
    setEdit(false);
    router.put(vacancies.update.path({ id: data.id }), { vacancy: data });
  });

  const match = useCallback(() => {
    router.post(matches.create.path(), { vacancy_id: vacancy.id, weights: weights })
  });

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="space-y-6">
        <VacancyForm vacancy={vacancy} vacancyFile={vacancy_file} />
        {edit ? (
          <VacancyEditMode
            vacancy={vacancy}
            onCancel={() => setEdit(false)}
            onUpdate={updateVacancy}
          />
        ) : (
          <VacancyViewMode vacancy={vacancy} onEdit={() => setEdit(true)} />
        )}
        <WeightSettings vacancy={vacancy} onUpdate={setWeights} />
        <div className="flex justify-end">
          <button
            onClick={match}
            className="inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors bg-blue-600 text-white hover:bg-blue-700"
          >
            开始匹配
          </button>
        </div>
      </div>
    </div>
  );
}
